<template>
 <div>
    <div class="downloadList" >
        <div class="search_container searchArea">
            <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">

                <el-form-item label="查找">
                    <el-input v-model="searchForm.searchText" placeholder="试卷名称"  @keyup.enter.native='handleSearch'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size ="mini" icon="search" @click='handleSearch'>查询</el-button>
                    <el-checkbox v-model="isSpecial" style="margin-left: 20px">启用特殊操作</el-checkbox>
                </el-form-item>

            </el-form>
        </div>
        <div class="table_container">
        <el-table v-loading="loading" :data="tableData" align='center' :height="myHeight-80" @row-click="rowClick">
          <el-table-column prop="exam_id" label="key" max-width="80"  align='center' ></el-table-column>
          <el-table-column prop="exam_name" label="考试名称" align='center' ></el-table-column>
          <el-table-column prop="exam_time" label="考试日期" align='center' ></el-table-column>
          <el-table-column prop="creater_name" label="创建老师(账号)" align='center' ></el-table-column>
          <el-table-column prop="score_report" min-width="120" label="剔除学生" align='center'  v-if="isSpecial">
            <template slot-scope='scope'>
              <el-button type="info" :disabled="scope.row.status!='ZC'" size="mini" @click='openIgnoreStudent(scope.row)'>设置</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="score_count" label="成绩单与试卷分析" align='center' width="150">
            <template slot-scope='scope'>
              <!-- <el-button type="primary" :disabled="scope.row.status!='ZC'" icon='edit' size="mini" @click='reCalcScore(scope.row, "SC")'>重新计算</el-button> -->
              <!-- <el-button type="text" :disabled="scope.row.status!='ZC'" icon='edit' size="mini" @click='downloadScoreCustom(scope.row)'>我的班级下载</el-button> -->

              <el-button type="primary" :disabled="!('status' in scope.row) || scope.row.status !='ZC'" icon='edit' size="mini" @click='down(scope.row)'>下载</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="score_report" min-width="120" label="成绩报告" align='center' >
            <template slot-scope='scope'>
              <el-button type="primary" :disabled="!('status' in scope.row) || scope.row.status !='ZC'" size="mini" @click='openScoreReport(scope.row)'>生成</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="re_score" min-width="120" label="成绩重算" align='center' v-if="isSpecial">
            <template slot-scope='scope'>
              <el-button type="other" icon='edit' :disabled="scope.row.status!='ZC'" size="mini" @click='reCalcScore(scope.row, "CJ")'>核算成绩(慢)</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="re_mark" min-width="120" label="第一步" align='center' >
            <template slot-scope='scope'>
              <!-- <el-button type="warning" icon='edit' size="mini" @click='reMarkExam(scope.row)'>绘制答题卡</el-button> -->

              <!-- <el-button type="warning" icon='edit' size="mini" @click='reMarkExam(scope.row)' v-else>教师/绘制答题卡</el-button> -->

 <!--              
--      整场考试（计算成绩单 绘制图像 zip下载）
      sc.status, -- 成绩统计状态（cj,zc) - 重新汇算成绩
      sc.packaging_status   -- 图像回值状态  --- 绘制图像
     
      sc.down_status,  -- 云盘下载状态(00,20,01)
      sc.down_nums, -- 云盘下载次数
      
      sc.packaging_nums, -- 绘制次数 (00,20,01)
      
      
--      教师本人（仅绘制和下载）
      ssct.status  as teacher_ctrl_status, -- 绘制/打包状态（cj,zc)
      ssct.status as teacher_packaging_status, -- 绘制/打包状态（cj,zc)
      
      ssct.down_status as teacher_down_status, -- 下载状态
      
      ssct.packaging_nums as teacher_packaging_nums, -- 打包次数
      ssct.down_nums as teacher_down_nums -- 下载次数
      
-->        

                <div v-if=" userInfo.id == scope.row.creater_id">
                    <!-- 用户为阅卷组长 -->
                    <div class="down-button">
 
                        <!-- 整场  -->
                        <el-button type="warning" icon='edit' size="mini" @click='reMarkExam(scope.row)' :disabled="!('status' in scope.row) || ! (scope.row.status == 'ZC' && (scope.row.packaging_status == '01' || !('packaging_status' in scope.row) ) )" >绘制整场考试</el-button> 
                        <el-button style="background-color:#67c23a;color:#fff" icon='edit' v-show=" ('status' in scope.row) &&  scope.row.status == 'ZC' && scope.row.packaging_status == '20' " size="mini" @click='showExamMarkProcess(scope.row,"exam")' >查看整场进度</el-button>
                    </div>
                    <div class="down-button">
                        <el-button type="warning" icon='edit' size="mini" @click='reMarkTeacherClass(scope.row)'  :disabled="!('teacher_packaging_status' in scope.row ? scope.row.teacher_packaging_status == '01' : scope.row.status == 'ZC' ) ">绘制所属班级</el-button>
                        <el-button style="background-color:#67c23a;color:#fff" icon='edit' v-show="('teacher_packaging_status' in scope.row) && scope.row.teacher_packaging_status == '20'" size="mini" @click='showExamMarkProcess(scope.row,"teacher")' >查看班级进度</el-button>
                    
                    
                    </div>
                    
                </div>
                <div v-else>
                    <!-- 仅参与 -->
                    <div class="down-button">
                        <!-- :disabled="!('teacher_packaging_status' in scope.row) || scope.row.teacher_packaging_status != '01'"  -->
                        <el-button type="warning" icon='edit' size="mini" @click='reMarkTeacherClass(scope.row)' :disabled="!('teacher_packaging_status' in scope.row ? scope.row.teacher_packaging_status == '01' : scope.row.status == 'ZC' ) ">绘制所属班级</el-button>
                        <el-button style="background-color:#67c23a;color:#fff" icon='edit' v-show="('teacher_packaging_status' in scope.row) && scope.row.teacher_packaging_status == '20'" size="mini" @click='showExamMarkProcess(scope.row,"teacher")'>查看班级进度</el-button>
                    </div>
                    
                </div>


            </template>
          </el-table-column>

 <!--              
--      整场考试（计算成绩单 绘制图像 zip下载）
      sc.status, -- 成绩统计状态（cj,zc) - 重新汇算成绩
      sc.packaging_status   -- 图像回值状态  --- 绘制图像
     
      sc.down_status,  -- 云盘下载状态(00,20,01)
      sc.down_nums, -- 云盘下载次数
      
      sc.packaging_nums, -- 绘制次数 (00,20,01)
      
      
--      教师本人（仅绘制和下载）
      ssct.status  as teacher_ctrl_status, -- 绘制/打包状态（cj,zc)
      ssct.status as teacher_packaging_status, -- 绘制/打包状态（cj,zc)
      
      ssct.down_status as teacher_down_status, -- 下载状态
      
      ssct.packaging_nums as teacher_packaging_nums, -- 打包次数
      ssct.down_nums as teacher_down_nums -- 下载次数
      
-->      

          <el-table-column prop="re_score" min-width="120" label="第二步" align='center' >
            <template slot-scope='scope'>
              <!-- <el-button type="primary" icon='edit' :disabled="scope.row.packaging_status!='01'" size="mini" @click='downloadStudentFile(scope.row)'>下载答题卡</el-button> -->
              <!-- <el-button type="primary" icon='edit' :disabled="scope.row.packaging_status!='01'" size="mini" @click='startDownload(scope.row)'>下载答题卡</el-button> -->

                <div v-if=" userInfo.id == scope.row.creater_id" >
                    <!-- 所属阅卷组长的考试 -->
                     <div class="down-button">
                         
                        <el-button type="primary" icon='edit'  :disabled="!('status' in scope.row) || ! (scope.row.status == 'ZC' && scope.row.packaging_status == '01' && scope.row.down_status == '01') "  size="mini" @click='startDownload(scope.row,"exam")'>下载整场考试</el-button>
                     </div>
                     <div class="down-button">
                        <el-button type="primary" icon='edit' :disabled=" !('teacher_packaging_status' in scope.row) || scope.row.teacher_packaging_status != '01' || scope.row.teacher_down_status != '01'" size="mini" @click='startDownload(scope.row,"teacher")' >下载所属班级</el-button>
                     </div>

                    
                </div>
                <div v-else>
                    <!-- 参与阅卷的考试 -->
                    <div class="down-button">
                        <el-button type="primary" icon='edit' :disabled="!('teacher_packaging_status' in scope.row) || scope.row.teacher_packaging_status != '01' || scope.row.teacher_down_status != '01'" size="mini" @click='startDownload(scope.row,"teacher")'>下载所属班级</el-button>
                       
                    </div>
                </div>
       
              
            </template>
          </el-table-column>

        </el-table>
        <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
        </div>


        <scoreReportDialog ref="scoreReportDialog" :info="selDownload" ></scoreReportDialog>
        <examTopicDialog ref="examTopicDialog"></examTopicDialog>
      <ignoreStudentDialog ref="ignoreStudentDialog" :ignoreStudent="selDownload2" @ok='reCalcScore(scope.row, "SC")'></ignoreStudentDialog>
      <download-progress-dialog ref="downloadProgressDialog" :down-url="downFileUrl" :down-file-name="downFileName" />
      <!-- 进度条 -->
      <remarkProcess ref="remarkProcess"></remarkProcess>

      <downloadScoreCustomDialog ref="downloadScoreCustomDialog"></downloadScoreCustomDialog>


      <!-- 百度云盘下载进度条 -->
      <el-dialog title='正在下载，请等待' width="20%"  :visible.sync="showProgress" :close-on-click-modal="false">
        <div style="text-align: center;">
            <el-progress :percentage="downloadProgress" type="circle"></el-progress>
        </div>
        <div style="text-align: center;" >{{ progressText }}</div>
      </el-dialog>

    
    
    </div>

    <el-dialog title="绘制答题卡设置" width="60%"  :visible.sync="dialogVisible" :close-on-click-modal="false">
          <div v-if="classType == 'NoneType'">
            <!-- <h1>行政班信息为空，请去<span style="color: #3587fc;">基础信息</span> - <span style="color: #3587fc;">我的行政班</span>  处设定行政班后再绘制答题卡</h1> -->
            <h1>考试 <span style="color: #3587fc;"> 行政班/教学班 </span>信息为空，请检查考试是否结束阅卷或是否已经扫描试卷</h1>
          </div>
          <div v-else style="margin: 10px">
            <div style="text-align: left;"  v-if="classType == 'teachingClass'">
                <h1 style="font-size: 20px;">教学班列表如下：</h1>
                <!-- <el-checkbox v-model="checkedAll" style="margin-top: 10px"> 全选</el-checkbox> -->
            </div>
            <div style="text-align: left;" v-else>
                <h1 style="font-size: 20px;">行政班列表如下：</h1>
                <!-- <el-checkbox v-model="checkedAll" style="margin-top: 10px"> 全选</el-checkbox> -->
            </div>
            <!-- <div style="text-align: left; margin-top: 10px">
                <el-checkbox-group v-model="checkedClass" style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px;">
                    <el-checkbox v-for="item in classList" :key="item.name" :label="item.name"  >{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> -->
            <div class="custom-transfer" style="margin-top: 10px">
                
                <el-transfer
                    filterable
                    v-model="checkedClass"
                    :data="filterData"
                    :titles="['待选班级', '已选班级']"
                    >
                </el-transfer>
            </div>


          </div>

          <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary"  v-if="classType != 'NoneType'" :loading="loadingCancel" @click="reMarkExamByCheck">选 中</el-button>
                <!-- <el-button type="primary"  v-if="classType != 'NoneType'"  @click="reMarkExamByTeacher">生 成</el-button> -->
            </div>
    </el-dialog>


    <el-dialog title="下载成绩单" width="20%"  :visible.sync="dialogDownXlsxVisible" :close-on-click-modal="false">
        <!-- <div style="height: 50px"> -->
            <el-button  type="primary" @click="downloadScoreStudentNo()">按学号排序下载</el-button>
            <el-button  type="primary" @click="downloadScore()">按成绩排序下载</el-button>
        <!-- </div> -->

    </el-dialog>

    <el-dialog title="绘制进度" width="35%"  :visible.sync="dialogVisibleProcess" :close-on-click-modal="false" @close="loadDownloadList()">

        <div style="text-align: center;" v-if="!processData.totalNum">
            <h1 style="font-size: 25px;margin-bottom: 10px;">考试号：{{ processData.examId }} 未点击绘制，请配置/点击绘制按钮后再下载 </h1>

        </div>
        <div v-else>
            <h1 style="font-size: 20px;margin-bottom: 10px;"> 考试号：{{ processData.examId }}</h1>
            <span style="font-size: 20px;"> 绘制进度 </span>
            <span style="font-size: 25px; color: #3587fc;margin-left: 5px;">  {{ processData.completedNum }} </span>
            <span style="font-size: 20px;"> / {{ processData.totalNum }} 条</span>

            
            <div style="text-align: center;margin-top: 10px;" >
                <el-button type="primary" @click="refreshProcess" >刷 新 </el-button>
                <!--  -->
            </div>
            <span style="font-size: 10px">绘制正在后台运行，点击可获取当前绘制进度</span>
            <div v-if="processData.completedNum == processData.totalNum" style="font-size: 25px;margin-top: 10px;">
                <el-tag type= 'success' style="font-size: 25px"> 图像绘制已结束，正在打包请稍等 </el-tag >
            </div>
           
        </div>


    </el-dialog>
</div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import { saveAs } from 'file-saver';
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";
    import scoreReportDialog from "./scoreReportDialog";
    import examTopicDialog from  "./examTopicDialog";
    import ignoreStudentDialog from "./ignoreStudentDialog";
    import downloadProgressDialog from "./downloadProgressDialog";
    import downloadScoreCustomDialog from "./downloadScoreCustomDialog";
    import remarkProcess from "./remarkProcess";
    import XLSX from "xlsx";
    import axios from "axios";
    import dayjs from 'dayjs'
    import { use } from 'echarts/core';

    export default {
        name: 'examsList',
        data(){
            return {
                tableData: [], tableHeight:0, downLoading: false, downFileUrl: null, downFileName: null,
                loading:false, isShow:false, selDownload: null, selDownload2: null, myHeight: 300, myWidth: 200,
                examList: [], selExam: null, archiveList: [],
                searchForm:{ pageNo: 1, pageSize: 50, totalCount: 0, searchText: null, examId: null},
                examForm: {archiveName: null},
                columnHeaders: { '基本信息': ['name', 'sex', 'age'], '成绩': ['class', 'teacher', 'score']},
                uploadUrl: null,
                uploadHeader: {
                    'Company-url': 'http://www.szpcyl.com',
                    'X-Powered-By': 'raozq',
                    'ke-Token': 'noLogin',
                    'ke-Domain': 'WB',
                },
                // 百度云盘下载进度条
                isDownloading: false,
                showProgress: false,
                downloadProgress: 0,
                progressText: '',
                dialogVisible:false,
                isSpecial: false,
                classType: "NoneType",
                classList: [],
                checkedClass:[],
                filterData:[],
                examId: null,
                // 下载学生成绩单弹窗
                dialogDownXlsxVisible: false,
                downScoreInfo: null,
                // 绘制进度弹窗
                dialogVisibleProcess: false,
                processData: {
                    examId: 100,
                    teacherId: null,
                    completedNum: 100,
                    totalNum: 100
                },
                loadingCancel: false,
                // 行数据
                currentRow: null

            }
        },
        components:{
            scoreReportDialog, examTopicDialog, ignoreStudentDialog, downloadProgressDialog, Pagination,remarkProcess,downloadScoreCustomDialog
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
                userToken: state => state.user.token,
            })
        },
        timers: {
          autoFresh: {time: 30000, autostart: false, repeat: true},
        },
      	mounted() {

            let that = this;
            this.$nextTick(()=>{
                let myHeight = document.documentElement.clientHeight -150;
                let myWidth = document.documentElement.clientWidth -250;
                console.log('myHeight', myHeight);
                that.myHeight = myHeight;
                that.myWidth = myWidth;
            })
            let myHost = process.env.NODE_ENV=='production'?window.g.PROD_HOST:window.g.DEV_HOST;
            this.uploadUrl = myHost + 'exam/archiveAtta/upload?';
            this.uploadHeader["ke-Token"] = this.userToken;
            this.loadDownloadList();
	   },
        methods: {
            handleSearch(){
              this.searchForm.pageNo = 1;
              this.loadDownloadList();
              if(!this.timers.autoFresh.isRunning) {
                this.$timer.start('autoFresh');
              }
            },
            autoFresh(){
              this.loadDownloadList();
            },
            loadDownloadList(){
                this.loading = true;
                this.selExam = null;
                this.archiveList = [];
                let search = { searchText: mUtils.searchText(this.searchForm.searchText), licenceId: this.userInfo.licenceId,userId: this.userInfo.id,
                    schoolId: null, teacherId: null, score: 'sum', orderBy: 'e.id desc'};
                let role = this.userInfo.role;
                if(role == "sclAdmin") search["schoolId"] = this.userInfo.schoolId;
                if(role == "teacher") {
                    // search["schoolId"] = this.userInfo.schoolId;
                    search["teacherId"] = this.userInfo.id;
                }
                // 判断用户是否是管理员/ 校级管理员，是则开放查看全部用户创建的考试
                if(this.userInfo.role == "sclAdmin" || this.userInfo.role == "admin") search['teacherId'] = null
                let param = { controllerName: 'exam', methodName: '/downloadExamList', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        let list = data.result;
                        this.tableData = list;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log("error")
                });
            },
            rowClick(row, column, e){
                this.selExam = row;
                this.loadArchive(row.exam_id)
            },
            loadArchive(examId){
                this.archiveList = [];
                let param = { controllerName: 'exam/archive', methodName: '/list', param: {examId: examId}};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("reloadArchive", data)
                    if (code == 0 && data && data.length > 0) {
                        this.archiveList = data;
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            handleChange(file, fileList) {
                console.log(file, fileList);
                if(file && "success" == file.status){
                    this.$message({ type: 'success', message: '上传成功!'});
                    this.loadArchive(file.response.file.examId);
                }
            },
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadDownloadList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadDownloadList()
            },
            reMarkExam(item){
              let that = this;
              this.$confirm('重绘答题卡需要几分钟，请耐心等待！，是否确认重绘?', '提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
              }).then(() => {
                // 同步行数据
                this.currentRow = null
                this.currentRow = item
                let param = { controllerName: 'score/ctrl', methodName: '/updateStatus', param: { examId: item.exam_id, packagingStatus: '00' }};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                  if (code == 0) {
                    // this.currentRow.packaging_status = '20'
                    this.$set(this.currentRow, 'packaging_status', '20');

                    that.$message({ type: 'success', message: '答题卡开始绘制，请等待!'});
                    // this.$refs.remarkProcess.loading(item.exam_id)
                    // that.loadDownloadList();
                  }
                });
              }).catch(() => {

              });
            },
            reMarkTeacherClass(item){
                // 同步行数据
                this.currentRow  = null
                this.currentRow  = item

                let param = { controllerName: 'score/ctrl', methodName: '/teacher/filterClass', param: { examId: item.exam_id,teacherId: this.userInfo.id }};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    if (Object.keys(data).length === 0) {
                        this.examId = null
                       this.classType = "NoneType"
                    } else {
                       this.examId = item.exam_id
                       this.classType = data.type
                       this.classList = data.classList
                       if(data.classList.length == 0){
                        this.classType  = "NoneType"
                       }
                       let filterData = []
                       // 过滤格式
                       data.classList.forEach((ele,index) => {
                            let params = {
                                key: ele.id,
                                label: ele.name
                            }
                            filterData.push(params)
                       });
                       this.filterData = filterData

                    }
                    this.dialogVisible = true
                })
 
            },
            // 绘制该场考试下属于自己的教学班/行政班学生
            reMarkExamByTeacher(){
                // this.$confirm('重绘所属学生的答题卡需要几分钟，请耐心等待！，是否确认重绘?', '提示', {
                //     confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                // }).then(() => {

                let param = { controllerName: 'score/ctrl', methodName: '/teacher/update', param: { examId: this.examId,teacherId: this.userInfo.id ,status: '00'}};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    if (code == 0) {
                        this.$message({message: '绘制成功，请稍等！', type: 'success', duration: 3000});
                    }else{
                        this.$message({message: '操作失败。。', type: 'error', duration: 3000});
                    }
                    this.handleSearch()
                    this.dialogVisible = false
                    
                })

            //   });
            },

            downloadStudentFile(item) {
              // this.$alert('准备下载答题卡需要几分钟，请耐心等待！', '提示', {
              //   confirmButtonText: '确定'
              // });
              // this.loading = true;
              // // saveAs(window.g.OSS_HOST+"answer/exam/"+item.licence_id+"/"+item.exam_id+"/all.zip?_=" + (new Date()).getTime(), item.exam_name+"_学生成绩.zip");
              // saveAs(window.g.OSS_HOST+"exam-mark/"+item.exam_id+"-mark.zip?_=" + (new Date()).getTime(), item.exam_name+"_学生成绩.zip");
              // this.loading = false;

              let url = window.g.OSS_HOST+"exam-mark/"+item.exam_id+"-mark.zip?_=" + (new Date()).getTime();
              let fileName = item.exam_name+"_学生成绩.zip"
              // saveAs(url, fileName);
              this.downFileName = fileName
              this.downFileUrl = url;
            //   this.$refs.downloadProgressDialog.examId = item.exam_id
              this.$refs.downloadProgressDialog.showDialog();
            },
            down(item){
                this.downScoreInfo = item
                this.dialogDownXlsxVisible = true
            },
            downloadScore(){
                let item = this.downScoreInfo
                let time_ = dayjs().format('YYYYMMDD_HHmm') 
                let fileName = item.exam_name + '(' + item.exam_id + ')-学生成绩(成绩排序)_' + time_ +'.xlsx'
                saveAs(window.g.OSS_HOST+"answer/analyse/"+item.exam_id+"/student.xlsx?_=" + (new Date()).getTime(), fileName);

                // saveAs(window.g.OSS_HOST+"answer/analyse/"+item.exam_id+"/student.xlsx?_=" + (new Date()).getTime(), item.exam_name+"_学生成绩(成绩排序).xlsx");
            },
            downloadScoreStudentNo(){
                let item = this.downScoreInfo
                let time_ = dayjs().format('YYYYMMDD_HHmm') 
                let fileName = item.exam_name + '(' + item.exam_id + ')-学生成绩(学号排序)_' + time_ +'.xlsx'

                let url = window.g.OSS_HOST+"answer/analyse/"+item.exam_id+"/student_no.xlsx?_=" + (new Date()).getTime()

                // 先检测文件是否存在
                fetch(url, { method: 'HEAD' })
                .then(res => {
                    if (res.ok) {
                        saveAs(url, fileName);
                        // saveAs(url, item.exam_name + "_学生成绩(学号排序).xlsx");
                    } else {
                        this.$message.warning("按学号排序成绩单暂未生成，请重新生成成绩单");
                    }
                })
                .catch(err => {
                    this.$message.error("按学号排序成绩单暂未生成，请重新生成成绩单");
                });

            },
            downloadArchiveFile(item) {
                this.loading = true;
                saveAs(window.g.OSS_HOST+item.oss_name+"?_=" + (new Date()).getTime(), item.file_name);
                this.loading = false;
            },
            addArchiveName(){
                let that = this;
                this.$refs.examForm.validate((valid) => {
                    if (valid) {
                        let param = { controllerName: 'exam/archive', methodName: '/saveOrUpdate', param: { name: that.examForm.archiveName, examId: that.selExam.exam_id, teacherId: this.userInfo.id }};
                        simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                            if (code == 0) {
                                that.$message({ type: 'success', message: '添加成功!'});
                                that.loadArchive(that.selExam.exam_id);
                            }
                        });
                    }
                });

            },
            delArchive(row){
                let that = this;
                this.$confirm('是否删除'+row.file_name+'?', '提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(() => {

                    let param = { controllerName: 'exam/archive', methodName: '/delete', param: { id: row.id }};
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        if (code == 0) {
                            that.$message({ type: 'success', message: '删除成功!'});
                            that.loadArchive(that.selExam.exam_id);
                        }
                    });
                }).catch(() => {

                });
            },
            delAtta(row){
                let that = this;
                this.$confirm('是否删除此材料?', '提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(() => {

                    let param = { controllerName: 'exam/archiveAtta', methodName: '/delete', param: { id: row.id }};
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        if (code == 0) {
                            that.$message({ type: 'success', message: '删除成功!'});
                            that.loadArchive(that.selExam.exam_id);
                        }
                    });
                }).catch(() => {

                });
            },
            reCalcScore(item, status){
                let that = this;
                let msg = '此操作会使整张试卷所有学生成绩重新计算一遍，耗时较长，是否确认重算?';
                if(status == 'SC') msg = '确认重新生成报表？';
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(() => {

                    let param = { controllerName: 'score/ctrl', methodName: '/updateStatus', param: { examId: item.exam_id, status: status }};
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        if (code == 0) {
                            that.$message({ type: 'success', message: '重算成功!'});
                            that.loadDownloadList();
                        }
                    });
                }).catch(() => {

                });
            },

            outputXlsxFile(data, wscols, xlsxName) {
                console.log(data, wscols, xlsxName)
                let sheetNames = [];
                let sheetsList = {};
                let wb = XLSX.utils.book_new();

                for (let key in data) {
                    sheetNames.push(key);
                    let columnHeader = this.columnHeaders[key] // 此处是每个sheet的表头
                    let temp = this.transferData(data[key], columnHeader);
                    sheetsList[key] = XLSX.utils.aoa_to_sheet(temp);
                    sheetsList[key]["!cols"] = wscols;
                }
                console.log("sheetNames", sheetNames)
                wb["SheetNames"] = sheetNames;
                wb["Sheets"] = sheetsList;

                XLSX.writeFile(wb, xlsxName + ".xlsx");
            },
            transferData(data, columnHeader) {
                let content = [];
                content.push(columnHeader);
                data.forEach((item, index) => {
                    let arr = [];
                    columnHeader.map(column =>{
                        arr.push(item[column]);
                    })
                    content.push(arr);
                });
                return content;
            },
            loadExamCtrl(item){
                this.loading = true;
                let that = this;
                let h = window.location.protocol;
                axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
                axios({
                    method:'get',
                    url: window.g.OSS_HOST+"answer/analyse/"+item.exam_id+"/exam_student_"+item.exam_id+".json",
                }).then((res)=>{
                    let data = res.data;
                    console.log(data);
                    that.examCount.joinCount = data.join_count;
                    that.examCount.totalCount = data.student_count;
                    that.examCount.hardClassCount = data.hard_count;
                    that.examInfo.totalScore = data.full_score;
                    that.examCount.maxScore = data.score_max;
                    that.examCount.avaScore = data.score_avg;
                    that.examInfo.hard = data.hard_mode;
                    that.examInfo.diff = data.discrimination;
                    let score_level = data.score_level;
                    let good_count = 0, up_count = 0;
                    for (let i=0; i<score_level.length; i++){
                        if(score_level[i].name == "优秀") good_count = score_level[i].count;
                        if(score_level[i].name != "不及格") up_count = up_count + score_level[i].count;
                    }
                    that.examCount.goodScale = Math.round(good_count/data.join_count *10000 )/100 ;
                    that.examCount.upScale = Math.round(up_count/data.join_count*10000)/100;
                    that.setScoreBarData(data.score_count);
                    that.setScoreLevelData(data.score_level);
                    that.setClassBarData(data.hard_avg_count);
                    that.tiData = data.scores;
                    that.jsonData = data;
                    that.loading = false;
                }).catch((error) => {
                    that.loading = false;
                });

            },
            openScoreReport(row){
                this.selDownload = row;
                this.$refs.scoreReportDialog.showDialog();
            },
            openIgnoreStudent(row){
              this.selDownload2 = row;
              this.$refs.ignoreStudentDialog.showDialog();
            },
            showExamTopicDialog(row){
                this.$refs.examTopicDialog.loadExamTopicList(row.exam_id);
                this.$refs.examTopicDialog.showDialog();
            },
            downCheckUrl(item){
                
                // if(this.userInfo.licenceKey == 'fzsk'){
                    // this.downByBaidu(item)
                    this.startDownload(item)
                // }else {
                    // this.downloadStudentFile(item)
                // }
                // 点击后获取到总文件大小，弹窗进度条

            },
            // 百度链接下载
            downByBaidu(item){
            
                let fileName = item.exam_id + '-mark.zip'
                 fetch(window.g.BAIDU_DOWN_URL + `/api/download?file_name=${encodeURIComponent(fileName)}`)
                    .then(response => {
                        if (!response.ok) throw new Error('下载失败');
                     
                        // 获取文件总大小
                        const contentLength = response.headers.get('Content-Length');
                        const totalSize = response.headers.get('X-Total-Size');
                        
                        // 输出文件大小（单位是字节）
                        console.log('Content-Length:', contentLength);
                        console.log('X-Total-Size:', totalSize);
                        
                        // 如果你需要转换为更易读的单位（如MB）
                        const fileSizeMB = (parseInt(contentLength) / (1024 * 1024)).toFixed(2);
                        console.log('文件大小:', fileSizeMB, 'MB');
                        
   
                        return response.blob();
                    })
                    .then(blob => {
                        console.log("=============================================")
                        console.log(blob)
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    })
                    .catch(error => console.error('下载错误:', error));
            },

            // 格式化文件大小（字节转MB/KB）
            formatFileSize(bytes) {
                if (bytes < 1024) {
                    return bytes + ' B';
                } else if (bytes < 1024 * 1024) {
                    return (bytes / 1024).toFixed(2) + ' KB';
                } else {
                    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
                }
            },
            
            async startDownload(item,type) {
                let fileName = item.exam_id + '-mark.zip'
                let downName = item.exam_id + '-mark.zip'
                if(type == 'teacher'){
                    fileName = this.userInfo.id + "/" + item.exam_id +"_" + this.userInfo.userName +'-mark.zip' 
                    // fileName =  item.exam_id + "-" + this.userInfo.nickName + '-mark.zip' 

                    // 使用教师工号
                    // downName =  item.exam_id + "-" + this.userInfo.nickName + '-mark.zip' 
                    downName =  item.exam_id + "-" + this.userInfo.userName + '-mark.zip' 
                }
                // let fileName =  '2181-mark.zip'

                this.isDownloading = true;
                this.showProgress = true;
                this.downloadProgress = 0;
                this.progressText = '准备下载...';

                try {
                        const response = await fetch(
                            window.g.BAIDU_DOWN_URL + `/api/download?file_name=${encodeURIComponent(fileName)}&type=${type}`
                        );
                        if (!response.ok) {
                        try {
                            const errorData = await response.json();
                            // 直接显示后端返回的message，如果不存在就显示默认消息
                            this.progressText = errorData.message || '下载失败';
                        } catch {
                            this.progressText = '下载失败';
                        }
                        
                        this.isDownloading = false;
                        // this.notifyDownloadResult(item.exam_id, 'UN');
                        
                        setTimeout(() => {
                            this.showProgress = false;
                        }, 5000);
                        return;
                    }

                        // 获取文件总大小
                        const contentLength = response.headers.get('Content-Length');
                        const totalSize = parseInt(contentLength, 10);
                        
                        if (isNaN(totalSize)) { 
                            // 触发下载成功通知
                            // this.notifyDownloadResult(item.exam_id,'UN')
                            throw new Error('无法获取文件大小，无法显示进度'); 
                        }

                        // 使用 getReader 读取流数据
                        const reader = response.body.getReader();
                        const contentEncoding = response.headers.get('Content-Encoding');
                        let receivedSize = 0;
                        const chunks = [];

                        while (true) {
                            const { done, value } = await reader.read();
                            if (done) {
                                break;
                            }
                            chunks.push(value);
                            receivedSize += value.byteLength;
                            
                            // 计算进度百分比
                            const progress = Math.round((receivedSize / totalSize) * 100);
                            this.downloadProgress = progress;
                            
                            // 更新进度文本
                            // this.progressText = `正在下载: ${this.formatFileSize(receivedSize)} / ${this.formatFileSize(totalSize)}`;
                            this.progressText = `${this.formatFileSize(receivedSize)} / ${this.formatFileSize(totalSize)}`;
                        }

                        // 下载完成，处理文件
                        this.progressText = '正在准备文件...';
                        const blob = new Blob(chunks);
                        const url = URL.createObjectURL(blob);
                        
                        // 创建下载链接并点击
                        const a = document.createElement('a');
                        a.href = url;
                        // a.download = fileName;
                        a.download = downName;
                        document.body.appendChild(a);
                        // 触发浏览器下载
                        a.click();

                   
                        // 触发下载成功通知
                        // this.notifyDownloadResult(item.exam_id,'01')

                        // 清理
                        setTimeout(() => {
                            document.body.removeChild(a);
                            URL.revokeObjectURL(url);
                            this.showProgress = false;
                            this.isDownloading = false;
                        }, 100);

                    } catch (error) {
                        // console.error('下载错误:', error);
                        // this.progressText = `下载失败: ${error.message}`;
                        debugger
                        
                        this.progressText = `下载失败`;
                        this.isDownloading = false;
                        // 触发下载成功通知
                        // this.notifyDownloadResult(item.exam_id,'UN')
                    // 5秒后隐藏错误信息
                    setTimeout(() => {
                        this.showProgress = false;
                    }, 5000);
                }
            },

            async notifyDownloadResult(examId,status) {
                try {
                    const response = await fetch(
                         window.g.BAIDU_DOWN_URL + `/api/downStatus?exam_id=${encodeURIComponent(examId)}&status=${encodeURIComponent(status)}`
                        );
                }catch (error) {

                }
            },
            // 自定义下载
            downloadScoreCustom(item){
                this.$refs.downloadScoreCustomDialog.getHardList(item.exam_id)
            },

            // 前端按钮点击事件
            async getDownloadUrlAndDownload(item,type) {
                 let fileName = item.exam_id + '-mark.zip'
                // 1. 调用你的接口
                const res = await fetch(`/api/download?file_name=${encodeURIComponent(fileName)}&type=${type}`);
                const data = await res.json();

                // 2. 判断是否成功
                if (data.status === 'success') {
                    // 3. 提取真实链接，触发下载
                    const aTag = document.createElement('a');
                    aTag.href = data.download_url; // 真实百度网盘链接
                    aTag.download = data.filename; // 下载文件名
                    aTag.click();
                } else {
                    alert(data.message); // 失败提示
                }
            },
            handleDownload(item,type) {
                 let fileName = item.exam_id + '-mark.zip'
                // 直接跳转至代理接口，无需处理real_download_url
                // const fileName = "283-mark.zip";
                type = "exam";
                window.location.href = `/api/proxy_download?file_name=${fileName}&type=${type}`;
            },
            // 教师绘制 根据自定义勾选的班级进行生成 判断勾选的班级记录中是否存在，存在则直接下载 不存在就更新记录并进行绘制
            reMarkExamByCheck(){
                debugger
                // 点击选中后 修改行状态为20直至下次tableData刷新
                // this.currentRow.teacher_ctrl_status = '20'
                this.$set(this.currentRow, 'teacher_ctrl_status', '20');
                this.loadingCancel = true
                // debugger
                // 选中的班级名称过滤对应的id 并排序
                let selectList  = this.checkedClass
                // 如果未选中班级不允许保存
                if(this.checkedClass.length == 0){
                    this.$message.info('请选择要绘制的班级!')
                    this.loadingCancel = false
                    return
                }
                console.log("111");

                // let list = this.classList
                // let filterList = list.filter(item => selectList.includes(item.name))
                // 过滤取出id后 使用升序排序并拼接
                // let ids = [...new Set(filterList.map(item => item.id))].sort((a, b) => a.localeCompare(b))

                let ids = [...new Set(selectList.map(item => item))].sort((a, b) => a.localeCompare(b))
                let ids_str = ids.join(",")
                // 新增教师绘制列表

                let params = {
                    examId: this.examId,
                    teacherId: this.userInfo.id ,
                    status: '00',
                    classType: this.classType,
                    classIds: ids_str
                }
                let param = { controllerName: 'score/ctrl', methodName: '/teacher/update', param: params};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    
                        if (code == 0) {
                            this.$message({message: '保存绘制配置成功，请等候图像绘制', type: 'success'});
                        }else{
                            this.$message({message: '保存失败，请询问工作人员。', type: 'error'});
                        }
                    setTimeout(() => {  
                        // this.loadDownloadList()
                        this.cancel()
                        this.loadingCancel = false
                    }, 2000);
                    
                })

            },
            cancel(){
                // this.loadDownloadList()
                this.checkedClass = []
                this.dialogVisible = false
            },
            getMarkProcess(examId,teacherId){
                try {
                    // 添加请求头 防止跨域
                    axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
                    axios({
                        method:'get',
                        url: window.g.BAIDU_DOWN_URL + `/api/getExamMarkProgress?examId=${encodeURIComponent(examId)}&teacherId=${encodeURIComponent(teacherId)}`
                    }).then((res)=>{
                        let data = res.data.data
                        this.processData = data
                        this.dialogVisibleProcess = true
                    })
                }catch (error) {

                }
            },
            // 查看绘制进度
            showExamMarkProcess(row,type){
                // 分辨绘制整场考试还是绘制指定班级
                let examId =  row.exam_id
                let teacherId = null
                if(type == 'teacher'){
                    teacherId =  this.userInfo.id 
                }
                // 本科院校区分整场考试和指定班级下载，非本科院校仅整场考试下载
                // if(schoolType == '本科'){
                //     // 
                //     if(type == 'teacher') teacherId = this.userInfo.id 
                // }
                this.getMarkProcess(examId,teacherId)

            },
            // 刷新进度
            refreshProcess(){
                // debugger
                // 刷新进度同时 判断是否在打包上传 如果在打包上传提示稍等正在打包
                let examId = this.processData.examId
                let teacherId = this.processData.teacherId
                this.getMarkProcess(examId,teacherId)



            },
            getMarkProcessAll(row){
                try {
                    // debugger
                    let examId = row.exam_id
                    let teacherId = this.userInfo.id 
                    // 添加请求头 防止跨域
                    axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
                    axios({
                        method:'get',
                        url: window.g.BAIDU_DOWN_URL + `/api/getExamMarkProgressAll`
                    }).then((res)=>{
                        // debugger
                        let data = res.data
                        this.processData = data
                        this.dialogVisibleProcess = true
                    })
                    let a = 1
                }catch (error) {

                }
            },
            



            
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>

    .downloadList{
        // overflow-y: hidden;
        .detail {
            padding: 10px;
            border: 1px solid rgba(203, 202, 202, 0.71);
            border-radius: 15px;
        }
        .search_container{

        }
        .btnRight{
            float: right;
            margin-right: 0px !important;
        }
        .searchArea{
            background:rgba(255,255,255,1);
            border-radius:2px;
            padding: 18px 18px 0;
        }
        .table_container{
            padding: 10px;
            background: #fff;
            border-radius: 2px;
        }
        .el-dialog--small{
           width: 600px !important;
        }
        .pagination{
            text-align: left;
            margin-top: 10px;
        }
    }
    .head1{
            font-weight: bold;
            font-size: 18px;
        }
    .custom-transfer {
    // 加宽穿梭框左右面板
        ::v-deep .el-transfer {
            .el-transfer-panel {
                text-align: left;
                width: 35%; // 你想要的宽度
            }
            // 可选：加高内容区
            .el-transfer-panel__body {
                
                height: 500px;
            }
            .el-transfer-panel__list {
                text-align: left;
                height: calc(100% - 40px);
            }
        }
    }
    .down-button {
        display: flex;
        // 按钮间留间距 
        gap: 10px;
        // 按钮垂直居中，高度按内容来，不会互相拉伸
        align-items: center; 
        margin-bottom: 10px
    }



</style>


